// src/services/authService.ts
import { api } from "./api";

// Connexion SuperAdmin
export async function loginSuperAdmin(email: string, password: string) {
  const response = await api.post("token/", { email, password });
  return response.data;
}

// Connexion Utilisateur simple
export async function loginUser(email: string, password: string) {
  const response = await api.post("token/", { email, password });
  return response.data;
}

// Rafraîchir le token
export async function refreshToken(refresh: string) {
  const response = await api.post("token/refresh/", { refresh });
  return response.data;
}

